import React, { CSSProperties } from 'react';

import { CmsTitleProps, TextLevel, TextSize } from '~/types/Cms';

const CmsTitle = ({ data }: CmsTitleProps) => {
  const alignment = data.align || 'inherit';
  const Element = data.tag || 'div';
  const textSize = data.text_size;
  const textLevel = data.level;

  const textSizeMap: Record<TextSize, string> = {
    xs: 'display-6',
    s: 'display-5',
    m: 'display-4',
    l: 'display-3',
    xl: 'display-2',
    xxl: 'display-1',
  };

  const textSizeClass = (textSize && textSizeMap[textSize]) || 'display-2';

  const textLevelMap: Record<TextLevel, string> = {
    primary: '#000000',
    secondary: '#666666',
    tertiary: '#999999',
  };

  const textColor = textLevel ? textLevelMap[textLevel] : undefined;

  const style: CSSProperties = { textAlign: alignment };
  if (textColor) style.color = textColor;

  return (
    <Element className={textSizeClass} style={style}>
      {data.content}
    </Element>
  );
};

export default CmsTitle;
